import { Action, createReducer, on } from '@ngrx/store'
import { EmployeeState, initialEmployeeState } from '../state/employee.state'
import {
  fetch_employee_personal_info_success,
  fetch_employee_with_reference_details_success,
  update_employee_personal_info_success_action
} from '../action/employee.action'
import { EmployeeData } from '../../models/api.model'

export function employeeReducer(state: EmployeeState, action: Action) {
  return _employeeReducer(state, action)
}

const _employeeReducer = createReducer(
  initialEmployeeState,
  on(fetch_employee_personal_info_success, (state, employee) => {
    return {
      ...state,
      ...employee
    }
  }),
  on(update_employee_personal_info_success_action, (state, employee) => {
    return {
      ...state,
      ...employee
    }
  }),
  on(fetch_employee_with_reference_details_success, (state, employeeData: EmployeeData) => {
    return {
      ...state,
      ...employeeData.employeeModel,
      employeeComplianceReferenceDetailsModel: employeeData.employeeComplianceReferenceDetailsModel,
      employeeBankDetailModel: employeeData.employeeBankDetailModel
    }
  })
)
